import map from 'lodash/map';

export const slugify = slug =>
  slug
    .toLowerCase()
    .trim()
    .replace(/["'/%<>~?+=,.():;[\]{}!@#$%^&*_]/g, '')
    .replace(/[-\s]+/g, '-');

export const slugifyDomain = name =>
  name
    .replace(/[^a-zA-Z0-9]/g, '') // not a letter or number
    .toLowerCase();

export const bindField = (
  form,
  field,
  {
    error = 'error',
    value = 'value',
    checkbox = false,
    floatLabel = false,
    onChangeFn,
    onChange = 'onChange',
    onChangeReaction
  } = {},
  options = {}
) => {
  const props = {
    name: form.$(field).name,
    [value]: form.$(field).value || '',
    [error]: form.$(field).error
  };

  if (checkbox) {
    props.checked = form.$(field).value;
    props[onChange] = event => {
      form.$(field).sync(null, event.target.checked);

      if (typeof onChangeReaction === 'function') {
        onChangeReaction(event);
      }
    };
  } else {
    props[onChange] =
      onChangeFn ||
      (event => {
        if (event && event.target) {
          form.$(field).sync(event.target.value);

          if (typeof onChangeReaction === 'function') {
            onChangeReaction(event);
          }
        }
      });
  }

  if (floatLabel && form.$(field).label) {
    props.floatingLabelText = form.$(field).label;
  }

  if (options.onlyIntegers) {
    const regex = /^[1-9]\d*$/g;

    const isInteger = props.value.toString().match(regex);

    if (!isInteger) {
      props.value = '1';
    }

    // Allow for clearing the number and then insert a new one
    if (props.error === 'The entityNumber field is required.') {
      props.value = '';
    }
  }

  return props;
};

export const passInputProps = ({placeholder, onKeyPress, error, name, value, checked, onChange}) => ({
  placeholder,
  checked,
  name,
  value,
  onKeyPress,
  onChange,
  error
});

export const bindChips = (form, field, {placeholder = 'placeholder', error = 'error', floatLabel = false}) => ({
  value: form.$(field).value,
  [placeholder]: form.$(field).label,
  onRequestAdd: chip => form.$(field).sync([...form.$(field).value, chip]),
  onRequestDelete: chip => form.$(field).sync(form.$(field).value.filter(e => e !== chip)),
  [error]: form.$(field).error,
  ...(floatLabel === true && {floatingLabelText: form.$(field).label})
});

export const mapForSelect = (collection, propMap) =>
  map(collection, item => ({
    key: item[propMap.key],
    value: item[propMap.value],
    name: item[propMap.name]
  }));

export const removeSpaces = e => {
  return {target: {value: e.target.value.replace(/ /g, '')}};
};

export const syncTitleWithSlug = (event, form) => {
  const {value} = event.target;

  // We want to manipulate the input's value after the event handler
  // was processed. If we won't do that, the event handler may take
  // too much time, which sometimes prevents IE11 from catching
  // user input.

  window.setTimeout(() => {
    const field = form.$('slug');
    const newValue = slugify(value);

    if (newValue) {
      field.sync(newValue);
    } else {
      field.clear();
    }
  });
};

export const onEnter = cb => ({
  onKeyPress: e => {
    const {
      key,
      target: {value},
      shiftKey
    } = e;
    if (key === 'Enter' && !shiftKey) {
      e.preventDefault();
      cb(value);
    }
  }
});
